var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 0v1.333h4V0H10v1.333h2.667c.368 0 .666.299.666.667v10.667a.667.667 0 01-.666.666h-12A.667.667 0 010 12.667V2c0-.368.298-.667.667-.667h2.666V0h1.334zM12 6H1.333v6H12V6zm-3.31.757l.943.943-3.3 3.3-2.357-2.357.943-.943 1.414 1.414L8.69 6.757zm-5.357-4.09h-2v2H12v-2h-2v.666H8.667v-.666h-4v.666H3.333v-.666z",
    fill: "#2F2F2F"
  })));
}
export default __webpack_public_path__ + "static/media/calender-tick.0e22494f.svg";
export { SvgCalenderTick as ReactComponent };